/* CROMA theme JS — drawers, header, cart, variants, search, motion */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- helpers ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, ev, fn, opts) { el && el.addEventListener(ev, fn, opts); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, s = this; clearTimeout(t); t = setTimeout(function () { fn.apply(s, a); }, ms); }; }
  function money(cents) {
    var fmt = (window.Croma && window.Croma.moneyFormat) || 'R$ {{amount_with_comma_separator}}';
    var v = (cents / 100).toFixed(2);
    var comma = v.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, comma).replace(/\{\{\s*amount\s*\}\}/, v);
  }

  /* ---------- focus trap ---------- */
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  function trapFocus(container, e) {
    var nodes = $$(FOCUSABLE, container).filter(function (n) { return n.offsetParent !== null || n === document.activeElement; });
    if (!nodes.length) return;
    var first = nodes[0], last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  }

  /* ---------- overlay manager (drawers + search) ---------- */
  var Overlay = {
    current: null,
    lastFocus: null,
    scrim: null,
    init: function () {
      this.scrim = $('[data-scrim]');
      var self = this;
      on(this.scrim, 'click', function () { self.close(); });
      on(document, 'keydown', function (e) {
        if (!self.current) return;
        if (e.key === 'Escape') self.close();
        if (e.key === 'Tab') trapFocus(self.current, e);
      });
      /* delegated: survives Section Rendering re-renders (e.g. cart drawer head) */
      on(document, 'click', function (e) {
        var openBtn = e.target.closest ? e.target.closest('[data-open]') : null;
        if (openBtn) { e.preventDefault(); self.open(openBtn.getAttribute('data-open'), openBtn); return; }
        var closeBtn = e.target.closest ? e.target.closest('[data-close]') : null;
        if (closeBtn) self.close();
      });
    },
    open: function (id, trigger) {
      var el = document.getElementById(id);
      if (!el) return;
      if (this.current && this.current !== el) this.close(true);
      this.lastFocus = trigger || document.activeElement;
      this.current = el;
      el.classList.add('is-open');
      el.removeAttribute('aria-hidden');
      if (el.getAttribute('data-with-scrim') !== 'false' && this.scrim) this.scrim.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
      var focusEl = el.querySelector('[data-autofocus]') || el.querySelector(FOCUSABLE);
      if (focusEl) window.setTimeout(function () { focusEl.focus(); }, 60);
      document.dispatchEvent(new CustomEvent('croma:overlay:open', { detail: { id: id } }));
    },
    close: function (keepLock) {
      if (!this.current) return;
      this.current.classList.remove('is-open');
      this.current.setAttribute('aria-hidden', 'true');
      this.current = null;
      if (this.scrim) this.scrim.classList.remove('is-open');
      if (!keepLock) document.documentElement.style.overflow = '';
      if (this.lastFocus) { try { this.lastFocus.focus(); } catch (e) {} this.lastFocus = null; }
    }
  };

  /* ---------- header ---------- */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var overlayMode = header.classList.contains('site-header--overlay');
    var sentinel = $('[data-header-sentinel]');
    var lastY = 0;

    if (overlayMode && sentinel && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var out = !entries[0].isIntersecting;
        header.classList.toggle('is-solid', out);
        header.classList.toggle('is-bordered', out);
      }, { rootMargin: '-60px 0px 0px 0px' }).observe(sentinel);
    } else {
      header.classList.add('is-bordered');
    }

    on(window, 'scroll', debounce(function () {
      var y = window.scrollY;
      if (y > 600 && y > lastY + 8) header.classList.add('is-hidden');
      else if (y < lastY - 4 || y < 200) header.classList.remove('is-hidden');
      lastY = y;
    }, 30), { passive: true });

    /* mega menu */
    $$('[data-mega-trigger]', header).forEach(function (trigger) {
      var id = trigger.getAttribute('data-mega-trigger');
      var panel = document.getElementById(id);
      if (!panel) return;
      var timer;
      function openMega() { clearTimeout(timer); panel.classList.add('is-open'); trigger.setAttribute('aria-expanded', 'true'); }
      function closeMega(delay) { clearTimeout(timer); timer = setTimeout(function () { panel.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); }, delay == null ? 160 : delay); }
      on(trigger, 'mouseenter', openMega);
      on(trigger, 'mouseleave', function () { closeMega(); });
      on(panel, 'mouseenter', openMega);
      on(panel, 'mouseleave', function () { closeMega(); });
      on(trigger, 'click', function (e) {
        if (trigger.getAttribute('aria-expanded') === 'true') return; /* second click follows link */
        e.preventDefault(); openMega();
      });
      on(document, 'keydown', function (e) { if (e.key === 'Escape') closeMega(0); });
      on(panel, 'focusout', function (e) { if (!panel.contains(e.relatedTarget) && e.relatedTarget !== trigger) closeMega(0); });
    });
  }

  /* ---------- motion hero ---------- */
  function initHero() {
    var hero = $('[data-mhero]');
    if (!hero) return;
    var KEY = 'croma:intro';
    var played = false;
    try { played = sessionStorage.getItem(KEY) === '1'; } catch (e) {}
    if (reduceMotion) { hero.classList.add('is-played'); }
    else if (played) { hero.classList.add('is-quick', 'is-played'); }
    else {
      hero.classList.add('is-playing');
      try { sessionStorage.setItem(KEY, '1'); } catch (e) {}
      window.setTimeout(function () { hero.classList.add('is-played'); hero.classList.remove('is-playing'); }, 3400);
    }

    /* extra slides — auto rotation */
    var slides = $$('[data-mhero-slide]', hero);
    if (!slides.length) return;
    var dots = $$('[data-mhero-dot]', hero);
    var total = slides.length + 1;
    var idx = 0;
    var delay = (parseInt(hero.getAttribute('data-autoplay'), 10) || 6) * 1000;
    var timer;

    function go(n) {
      idx = (n + total) % total;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx - 1); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    function restart() {
      window.clearInterval(timer);
      if (reduceMotion) return;
      timer = window.setInterval(function () { go(idx + 1); }, delay);
    }
    dots.forEach(function (d, i) {
      on(d, 'click', function () { go(i); restart(); });
    });
    on(hero, 'mouseenter', function () { window.clearInterval(timer); });
    on(hero, 'mouseleave', restart);

    /* swipe horizontal */
    var swipeX = null, swipeY = null, swiped = false;
    on(hero, 'touchstart', function (e) {
      if (e.touches.length !== 1) { swipeX = null; return; }
      swipeX = e.touches[0].clientX; swipeY = e.touches[0].clientY; swiped = false;
      window.clearInterval(timer);
    }, { passive: true });
    on(hero, 'touchmove', function (e) {
      if (swipeX == null || swiped) return;
      var dx = e.touches[0].clientX - swipeX;
      var dy = e.touches[0].clientY - swipeY;
      if (Math.abs(dx) > 48 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        swiped = true;
        go(dx < 0 ? idx + 1 : idx - 1);
      }
    }, { passive: true });
    on(hero, 'touchend', function () {
      if (swiped) {
        on(hero, 'click', function block(e) { e.preventDefault(); hero.removeEventListener('click', block, true); }, { capture: true, once: true });
      }
      swipeX = null; restart();
    });

    /* mouse drag (desktop) */
    var mX = null, mY = null, mDown = false, mSwiped = false;
    on(hero, 'mousedown', function (e) {
      if (e.button !== 0) return;
      mDown = true; mSwiped = false; mX = e.clientX; mY = e.clientY;
      window.clearInterval(timer);
    });
    on(document, 'mousemove', function (e) {
      if (!mDown || mSwiped) return;
      var dx = e.clientX - mX, dy = e.clientY - mY;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        mSwiped = true;
        go(dx < 0 ? idx + 1 : idx - 1);
      }
    });
    on(document, 'mouseup', function () {
      if (!mDown) return;
      mDown = false;
      if (mSwiped) {
        on(hero, 'click', function block(e) { e.preventDefault(); e.stopPropagation(); }, { capture: true, once: true });
      }
      restart();
    });
    on(hero, 'dragstart', function (e) { e.preventDefault(); });

    restart();
  }

  /* ---------- reveal on scroll ---------- */
  function initReveal() {
    if (reduceMotion || !('IntersectionObserver' in window)) {
      $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  }

  /* ---------- cart ---------- */
  var Cart = {
    sectionId: 'cart-drawer',
    refresh: function (openAfter) {
      var self = this;
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?sections=' + self.sectionId : '/?sections=' + self.sectionId)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          self.render(data[self.sectionId]);
          if (openAfter) Overlay.open('CartDrawer');
        });
    },
    render: function (html) {
      if (!html) return;
      var tpl = document.createElement('div');
      tpl.innerHTML = html;
      var next = tpl.querySelector('[data-cart-root]');
      var cur = $('[data-cart-root]');
      if (next && cur) cur.replaceWith(next);
      var count = tpl.querySelector('[data-cart-count]');
      $$('[data-cart-count]').forEach(function (el) {
        if (count && !el.closest('#CartDrawer')) el.textContent = count.textContent;
      });
      this.bind();
    },
    bind: function () {
      var self = this;
      $$('#CartDrawer [data-line-change]').forEach(function (btn) {
        on(btn, 'click', function () {
          var line = parseInt(btn.getAttribute('data-line'), 10);
          var qty = parseInt(btn.getAttribute('data-line-change'), 10);
          self.change(line, qty);
        });
      });
      $$('#CartDrawer [data-line-qty]').forEach(function (input) {
        on(input, 'change', function () {
          self.change(parseInt(input.getAttribute('data-line'), 10), Math.max(0, parseInt(input.value, 10) || 0));
        });
      });
    },
    change: function (line, quantity) {
      var self = this;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function () { self.refresh(false); });
    },
    add: function (formData, button) {
      var self = this;
      if (button) button.classList.add('is-loading');
      formData.append('sections', self.sectionId);
      return fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (button) button.classList.remove('is-loading');
          if (data.status && data.status !== 200) {
            var status = $('[data-form-status]');
            if (status) { status.textContent = data.description || data.message; status.classList.add('form-status--error'); }
            return;
          }
          if (data.sections && data.sections[self.sectionId]) {
            self.render(data.sections[self.sectionId]);
            Overlay.open('CartDrawer');
          } else {
            self.refresh(true);
          }
        })
        .catch(function () { if (button) button.classList.remove('is-loading'); });
    }
  };

  /* product form */
  function initProductForms() {
    $$('form[data-product-form]').forEach(function (form) {
      on(form, 'submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        Cart.add(new FormData(form), btn);
      });
      var buyNow = form.querySelector('[data-buy-now]');
      if (buyNow) {
        on(buyNow, 'click', function () {
          if (buyNow.disabled || buyNow.getAttribute('aria-disabled') === 'true') return;
          buyNow.classList.add('is-loading');
          fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
            .then(function (r) { return r.json(); })
            .then(function (data) {
              if (data.status && data.status !== 200) {
                buyNow.classList.remove('is-loading');
                var status = $('[data-form-status]');
                if (status) { status.textContent = data.description || data.message; status.classList.add('form-status--error'); }
                return;
              }
              window.location.href = '/checkout';
            })
            .catch(function () { buyNow.classList.remove('is-loading'); });
        });
      }
    });
  }

  /* ---------- product image zoom ---------- */
  function initZoom() {
    var box = document.getElementById('PdpZoom');
    var json = $('[data-zoom-json]');
    if (!box || !json) return;
    var urls = [];
    try { urls = JSON.parse(json.textContent); } catch (e) { return; }
    if (!urls.length) return;
    var stage = $('[data-zoom-stage]', box);
    var img = $('[data-zoom-img]', box);
    var count = $('[data-zoom-count]', box);
    var coarse = window.matchMedia && window.matchMedia('(pointer: coarse)').matches;
    var idx = 0;

    function show(i) {
      idx = (i + urls.length) % urls.length;
      stage.classList.remove('is-zoomed');
      img.style.transformOrigin = '';
      img.src = urls[idx];
      if (count) count.textContent = (idx + 1) + ' / ' + urls.length;
    }
    function setOrigin(e) {
      var r = stage.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
    }

    $$('.pdp__frame[data-zoom-index]').forEach(function (frame) {
      var i = parseInt(frame.getAttribute('data-zoom-index'), 10);
      function openZoom() { show(i); Overlay.open('PdpZoom', frame); }
      on(frame, 'click', openZoom);
      on(frame, 'keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openZoom(); } });
    });

    on(stage, 'click', function (e) {
      var zoomed = stage.classList.toggle('is-zoomed');
      if (zoomed) {
        if (coarse) {
          var r = stage.getBoundingClientRect();
          var fx = (e.clientX - r.left) / r.width, fy = (e.clientY - r.top) / r.height;
          window.requestAnimationFrame(function () {
            stage.scrollLeft = (stage.scrollWidth - stage.clientWidth) * fx;
            stage.scrollTop = (stage.scrollHeight - stage.clientHeight) * fy;
          });
        } else {
          setOrigin(e);
        }
      } else {
        img.style.transformOrigin = '';
      }
    });
    on(stage, 'mousemove', function (e) {
      if (!coarse && stage.classList.contains('is-zoomed')) setOrigin(e);
    });

    var prev = $('[data-zoom-prev]', box), next = $('[data-zoom-next]', box);
    if (prev) on(prev, 'click', function () { show(idx - 1); });
    if (next) on(next, 'click', function () { show(idx + 1); });
    on(document, 'keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'ArrowLeft') show(idx - 1);
      if (e.key === 'ArrowRight') show(idx + 1);
    });
  }

  /* ---------- variant picker ---------- */
  function initVariantPickers() {
    $$('[data-variant-picker]').forEach(function (picker) {
      var scope = picker.closest('.shopify-section') || picker.closest('section') || document;
      var json = $('[data-variants-json]', scope) || $('[data-variants-json]');
      if (!json) return;
      var variants;
      try { variants = JSON.parse(json.textContent); } catch (e) { return; }
      var productUrl = picker.getAttribute('data-url') || location.pathname;
      var lastMediaId = null;
      var booted = false;

      function swipeToMedia(v) {
        var mid = v.featured_media && v.featured_media.id;
        if (!mid) return;
        if (!booted) { lastMediaId = mid; return; }
        if (mid === lastMediaId) return;
        lastMediaId = mid;
        var frame = document.querySelector('.pdp__frame[data-media-id="' + mid + '"]');
        if (!frame) return;
        frame.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
        if (!reduceMotion) {
          frame.classList.remove('is-swap');
          void frame.offsetWidth;
          frame.classList.add('is-swap');
        }
      }

      function selectedOptions() {
        var opts = [];
        $$('[data-option-index]', picker).forEach(function (group) {
          var checked = group.querySelector('input:checked');
          if (checked) opts[parseInt(group.getAttribute('data-option-index'), 10)] = checked.value;
        });
        return opts;
      }
      function findVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }
      function update() {
        var v = findVariant(selectedOptions());
        var idInput = $('[data-variant-id]');
        var buyBtns = $$('[data-buy-button]');
        var priceEls = $$('[data-price-target]');
        if (!v) {
          buyBtns.forEach(function (b) { b.setAttribute('aria-disabled', 'true'); b.querySelector('span').textContent = (window.Croma && window.Croma.t.unavailable) || 'Indisponível'; });
          return;
        }
        if (idInput) idInput.value = v.id;
        priceEls.forEach(function (el) {
          el.innerHTML = v.compare_at_price && v.compare_at_price > v.price
            ? '<span class="price--sale"><s class="price__old">' + money(v.compare_at_price) + '</s>' + money(v.price) + '</span>'
            : money(v.price);
        });
        buyBtns.forEach(function (b) {
          var label = b.querySelector('span');
          if (v.available) { b.removeAttribute('aria-disabled'); b.removeAttribute('disabled'); if (label) label.textContent = b.getAttribute('data-label-add'); }
          else { b.setAttribute('disabled', ''); if (label) label.textContent = b.getAttribute('data-label-soldout'); }
        });
        try { history.replaceState({}, '', productUrl + '?variant=' + v.id); } catch (e) {}
        swipeToMedia(v);
        /* availability marks on other groups */
        $$('[data-option-index]', picker).forEach(function (group) {
          var idx = parseInt(group.getAttribute('data-option-index'), 10);
          $$('.opt-pill', group).forEach(function (pill) {
            var val = pill.querySelector('input').value;
            var probe = selectedOptions(); probe[idx] = val;
            var pv = findVariant(probe);
            pill.classList.toggle('is-unavailable', !(pv && pv.available));
          });
        });
      }
      $$('input[type="radio"]', picker).forEach(function (input) { on(input, 'change', update); });
      update();
      booted = true;
    });
  }

  /* ---------- predictive search ---------- */
  function initSearch() {
    var screenEl = $('#SearchScreen');
    if (!screenEl) return;
    var input = $('[data-search-input]', screenEl);
    var results = $('[data-search-results]', screenEl);
    var label = $('[data-search-label]', screenEl);
    if (!input || !results) return;
    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; if (label) label.hidden = true; return; }
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var items = (((data.resources || {}).results || {}).products) || [];
          if (label) { label.hidden = false; label.textContent = items.length ? ((window.Croma && window.Croma.t.results) || 'Resultados') : ((window.Croma && window.Croma.t.noResults) || 'Nenhum resultado'); }
          results.innerHTML = items.map(function (p) {
            var img = p.featured_image && p.featured_image.url ? '<div class="product-card__media"><img class="is-primary" src="' + p.featured_image.url + '&width=600" alt=""></div>' : '<div class="product-card__media"></div>';
            return '<a class="product-card" href="' + p.url + '">' + img +
              '<div class="product-card__info"><span class="product-card__title">' + p.title + '</span>' +
              '<span class="product-card__price">' + p.price + '</span></div></a>';
          }).join('');
        });
    }, 240);
    on(input, 'input', run);
    on(document, 'croma:overlay:open', function (e) {
      if (e.detail.id === 'SearchScreen') window.setTimeout(function () { input.focus(); }, 80);
    });
  }

  /* ---------- PDP sticky bar ---------- */
  function initPdpSticky() {
    var bar = $('[data-pdp-sticky]');
    var anchor = $('[data-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }).observe(anchor);
  }

  /* ---------- accordions: animate <details> ---------- */
  function initAccordions() {
    $$('details.accordion').forEach(function (det) {
      var panel = $('.accordion__panel', det);
      var toggle = $('.accordion__toggle', det);
      if (!panel || !toggle || reduceMotion) return;
      on(toggle, 'click', function (e) {
        e.preventDefault();
        if (det.open) {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () {
            panel.style.transition = 'height 320ms cubic-bezier(0.65,0,0.35,1)';
            panel.style.height = '0px';
          });
          panel.addEventListener('transitionend', function h() {
            det.open = false; panel.style.cssText = ''; panel.removeEventListener('transitionend', h);
          });
        } else {
          det.open = true;
          var target = panel.scrollHeight;
          panel.style.height = '0px';
          requestAnimationFrame(function () {
            panel.style.transition = 'height 320ms cubic-bezier(0.65,0,0.35,1)';
            panel.style.height = target + 'px';
          });
          panel.addEventListener('transitionend', function h() {
            panel.style.cssText = ''; panel.removeEventListener('transitionend', h);
          });
        }
      });
    });
  }

  /* ---------- boot ---------- */
  function boot() {
    Overlay.init();
    initHeader();
    initHero();
    initReveal();
    initProductForms();
    initVariantPickers();
    initZoom();
    initSearch();
    initPdpSticky();
    initAccordions();
    Cart.bind();
  }
  if (document.readyState === 'loading') on(document, 'DOMContentLoaded', boot); else boot();

  window.CromaCart = Cart;
  window.CromaOverlay = Overlay;
})();
